// client/src/utils/translations.js

export const policyTypeNames = {
  'terms-of-use': 'Termos de Uso',
  'privacy-policy': 'Política de Privacidade',
  'lgpd': 'LGPD',
  'cancellation-policy': 'Política de Cancelamento',
};

export const audienceNames = {
  'platform_user': 'Usuário da Plataforma',
  'end_customer': 'Cliente Final',
};